import jSecure from "@linkedin/jsecure";
//Helper functions

// For logging purposes. Finished majority = viewing 90% of slideshow
const FINISHED_MAJORITY_DEFINITION = 0.9
function hasFinishedMajorityOfSlideshow(currentSlideIndex, slideCount) {
  const finishedIndex = Math.floor(slideCount * FINISHED_MAJORITY_DEFINITION)
  return currentSlideIndex === finishedIndex
}
var hasLoggedSlideShowStarted = false
var hasIdentifiedAmplitude = false

if (typeof window.cookie === "undefined") {
  window.cookie = function (name, value, options) {
    if (typeof value != "undefined") {
      options = options || {}
      if (value === null) {
        value = ""
        options.expires = -1
      }
      var expires = ""
      if (
        options.expires &&
        (typeof options.expires == "number" || options.expires.toUTCString)
      ) {
        var date
        if (typeof options.expires == "number") {
          date = new Date()
          date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000)
        } else {
          date = options.expires
        }
        expires = "; expires=" + date.toUTCString()
      }
      var path = options.path ? "; path=" + options.path : ""
      var domain = options.domain ? "; domain=" + options.domain : ""
      var secure = options.secure ? "; secure" : ""
      document.cookie = [
        name,
        "=",
        encodeURIComponent(value),
        expires,
        path,
        domain,
        secure,
      ].join("")
    } else {
      var cookieValue = null
      if (document.cookie && document.cookie !== "") {
        var cookies = document.cookie.split(";")
        for (var i = 0; i < cookies.length; i++) {
          var cookie = jQuery.trim(cookies[i])
          if (cookie.substring(0, name.length + 1) == name + "=") {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
            break
          }
        }
      }
      return cookieValue
    }
  }
  // return cookieValue;
}

// Event definitions
if ($.slideshareEventManager === undefined) {
  $.extend({
    slideshareEventManager: {
      SHOUTEVENTS: {
        next: true,
        previous: true,
        gotoslide: true,
        slidechanged: true,
        insight: true,
        flag: true,
      },
      i18n: slideshare_object.utils.i18n,
      functions: {
        showlastscreen: function () {
          var controller = this.controller
          if (controller.isValidNextSlideshowExperiment()) {
            this.trigger("showNextSlideshow")
          } else {
            controller.displayLastScreen()
          }
        },
        hidelastscreen: function () {
          if('hideLastScreen' in this.controller) {
            this.controller.hideLastScreen()
          }
        },
        gotofirstslide: function () {
          var controller = this.controller
          this.trigger("hideNextSlideshow")
          controller.play(1)
          // if video, restart the video
          if (controller.config.player_type === "video") {
            controller.multimediaResource &&
              controller.multimediaResource.videoPlayer.seek(0).play(true)
          }
        },
        next: function (data) {
          var controller = this.controller
          if (controller.mode == "iframe") {
            var displayer = controller.currentComponentSet.slidedisplayer
            displayer.next()
            return
          }
          var currentPosition = controller.currentPosition
          var lastPosition = controller.slideCount
          var touchedSlideNo = data && data.touchedSlideNo
          var navigate_to
          // play controls for video embeds
          var currentSlide = controller.slides[currentPosition]
          var nextSlide = controller.slides[currentPosition + 1]

          //touchedSlideNo is less than the numberOfSlides already loaded - 3 means user is looking at the upper slides
          //so just return to boost mobile new player performance.
          if (touchedSlideNo < currentPosition - 3) {
            return
          } else if (touchedSlideNo > lastPosition - 1) {
            controller.lastSlideReached()
          }

          if (currentSlide.config.slideMode === "ytube_video") {
            currentSlide._pauseVideo()
          }

          if (
            currentPosition === lastPosition &&
            typeof new_mobile_player === "undefined"
          ) {
            this.onLastSlide = true
            if (controller.isValidNextSlideshowExperiment()) {
              this.trigger("showNextSlideshow")
            } else {
              this.trigger("showlastscreen")
            }
          } else {
            this.onLastSlide = false
            var position = currentPosition + 1
            var source = data && data.source


            controller.play(position, false, source, { updateBamboo: true })

            if (source) {
              $.slideshareEventManager.trackEvent(source + "_" + position)
              $.slideshareEventManager.trackEvent(
                source + "_" + this.controller.currentViewMode
              )
            } else {
              source = "right_arrow_key"
              $.slideshareEventManager.trackEvent(source + "_" + position)
              $.slideshareEventManager.trackEvent(
                source + "_" + this.controller.currentViewMode
              )
            }
          }
        },
        previous: function (data) {
          var controller = this.controller
          if (controller.mode == "iframe") {
            var displayer = controller.currentComponentSet.slidedisplayer
            displayer.previous()
            return
          }
          var currentPosition = controller.currentPosition
          var navigate_to = currentPosition - 1
          var source = data && data.source
          this.trigger("hideNextSlideshow")
          controller.slides[currentPosition].stop()
          controller.play(navigate_to, false, source, { updateBamboo: true })
          data &&
            data.source &&
            $.slideshareEventManager.trackEvent(data.source + "_" + navigate_to)
        },
        showNextSlideshow: function () {
          this.controller.showNextSlideshowCTA()
        },
        hideNextSlideshow: function () {
          if (this.controller.isValidNextSlideshowExperiment()) {
            this.controller.hideNextSlideshowCTA()
          }
        },
        updateNextSlideshowCookie: function (slideshowId) {
          var slideshows = window.cookie("next_slideshows_seen_ids")
          var days = slideshowId === "clear" ? -1 : 1

          // Max cookie length is 4096, so we clear it at 4000 or append slideshows
          if (slideshows && slideshows.length >= 4000) {
            days = -1
          } else if (slideshows) {
            slideshows = slideshows.split(",")
            if (slideshows.indexOf(slideshowId.toString()) === -1) {
              slideshows.push(slideshowId)
            }
          } else {
            slideshows = [this.controller.config.id, slideshowId]
          }
          window.cookie("next_slideshows_seen_ids", slideshows, {
            expires: days,
            path: "/",
          })
        },
        mobileScrollPlayingMode: function (playingMode) {
          this.controller.playingMode = playingMode
        },
        gotolastslide: function () {
          var controller = this.controller
          var lastPosition = controller.slideCount
          controller.play(lastPosition)
        },
        document_touch_scroll: function (data) {
          this.controller.currentComponentSet.slidedisplayer.manualScroll(
            data.delta
          )
        },
        toggleaudio: function () {
          var controller = this.controller
          controller.multimediaResource &&
            controller.multimediaResource.togglePlay()
        },
        audioplayed: function () {
          var controller = this.controller
          controller.currentComponentSet.toolbar.updateAudioInteraction({
            audioPlaying: true,
          })
        },
        audiopaused: function () {
          var controller = this.controller
          controller.currentComponentSet.toolbar.updateAudioInteraction({
            audioPlaying: false,
          })
        },
        videoready: function (data) {
          var controller = this.controller
          controller.initVideoPlayer(data.mode)
          controller.currentComponentSet.videobar._bindEvents()
        },
        gotoslide: function (data) {
          var controller = this.controller
          controller.play(data.index, undefined, undefined, {
            updateBamboo: true,
          })
          this.trigger("hideNextSlideshow")
          $.slideshareEventManager.trackEvent("jumptoslide_" + data.index)
        },
        viewonss: function (e) {
          var controller = this.controller
          window.open(
            jSecure.sanitizeUrl(controller.config.slideview_url),
            "viewer"
          )
        },
        viewfullscreen: function (e) {
          var controller = this.controller
          var compSet = controller.currentComponentSet
          if (
            controller.currentViewMode == "nativefullscreen" ||
            controller.currentViewMode == "fullscreen"
          ) {
            return
          }

          // If document, reset zoom before going fullscreen
          if (controller.config.player_type === "document") {
            compSet.slidedisplayer.setZoom(0)
          }
          if (compSet.videobar) {
            compSet.slidedisplayer.adjustSpinnerPosition(true)
          }

          if (controller.isNativeFullScreenSupported) {
            compSet.container.addClass("fullscreen")
            controller.switchNativeView("nativefullscreen")
            controller.currentComponentSet.toolbar.showFullscreenToolbar(true)
          } else {
            controller.switchToFullScreen()
          }

          controller.currentComponentSet.toolbar.showFullscreenToolbar(true)

          if (controller.currentViewMode === "nativefullscreen") {
            // Track new pageload events for native fullscreen (regular
            // fullscreen loads in a new window and so is already tracking
            // pageviews)
            _gaq.push([
              "_trackPageview",
              "/" + this.hostedIn + "FullscreenView",
            ])
          }
        },
        leavefullscreen: function (e) {
          var controller = this.controller

          controller.currentComponentSet.toolbar.showFullscreenToolbar(false)

          if (controller.currentViewMode == "normal") {
            return
          }
          controller.leaveFullScreen()

          // Hide title banner
          if (controller.currentComponentSet.toolbar.$fullscreenTitleBanner) {
            controller.currentComponentSet.toolbar.$fullscreenTitleBanner.hide()
          }
        },
        zoomin: function (e) {
          var controller = this.controller
          controller.currentComponentSet.slidedisplayer.zoomin()
        },
        zoomout: function (e) {
          var controller = this.controller
          controller.currentComponentSet.slidedisplayer.zoomout()
        },
        playersearch: function (e) {},
        playershare: function (data) {
          if (!this.controller) {
            return;
          }
          this.controller.displayShareScreen({
            gaCategory: data,
            customizations: {
              title: this.i18n(
                "ssplayer.event_manager.playershare.share_slideshare"
              ),
            },
          })
          // If video, pause.
          if (this.controller.config.player_type === "video") {
            this.controller.multimediaResource &&
              this.controller.multimediaResource.pause()
          }
        },
        metadataloaded: function (data) {
          var controller = this.controller
          var metaDataType = data.type
          var handlers = controller._metaDataHandlers()[metaDataType]
          handlers.success.call(controller, data.json)
        },
        metadataloadfailed: function (data) {
          var controller = this.controller
          var metaDataType = data.type
          var handlers = controller._metaDataHandlers()[metaDataType]
          handlers.failure.call(controller)
          this.trackRawEvent(
            "jsplayer_debug",
            metaDataType + "_metadataloadfailed",
            undefined,
            true
          )
        },
        slidechanged: function (data) {
          this.trigger("hidelastscreen")
          var slideIndex = data.index
          var controller = this.controller
          var currentPosition = controller.currentPosition
          var isStartSlideYtubeEmbed =
            controller.config.has_video &&
            controller.config.video_hash[controller.config.start_slide]
          if (currentPosition === slideIndex && !data.force) {
            return
          }

          if (
            hasFinishedMajorityOfSlideshow(slideIndex, controller.slideCount)
          ) {
            const slideshow = slideshare_object.slideshow
            const eventAttributes = {
              slideshow_id: slideshow.id,
              slideshow_created_at: slideshow.slideshow_created_at,
              slideshow_category: slideshare_object.gam_cat_name,
              slideshow_language: slideshow.slideshow_language,
              slideshow_format: slideshow.type,
              slideshow_finished_definition:
                "viewed_" + FINISHED_MAJORITY_DEFINITION * 100 + "%",
            }

            this.trackAmplitudeEvent("slideshow_finished", eventAttributes)
          }

          if (slideIndex > 1 && !hasLoggedSlideShowStarted) {
            hasLoggedSlideShowStarted = true
            const slideshow = slideshare_object.slideshow
            const eventAttributes = {
              slideshow_id: slideshow.id,
              slideshow_created_at: slideshow.slideshow_created_at,
              slideshow_category: slideshare_object.gam_cat_name,
              slideshow_language: slideshow.slideshow_language,
              slideshow_format: slideshow.type,
              slideshow_started_definition: "viewed_any_page_other_than_init",
            }

            this.trackAmplitudeEvent("slideshow_started", eventAttributes)
          }

          if('updateCurrentPosition' in this.controller){
            this.controller.updateCurrentPosition(slideIndex)
          }
          if('hideShareScreen' in this.controller){
            this.controller.hideShareScreen()
          }

          if (controller.config.related_position > 0) {
            $.slideshareEventManager.trackEvent(
              "related" + controller.config.related_position + "_slide_changed"
            )
          }

          // preload and prerender slides as appropriate
          if (!data.mobile) {
            if (
              slideIndex === controller.config.start_slide &&
              controller.config.show_image_player &&
              !isStartSlideYtubeEmbed
            ) {
              controller._load(slideIndex, true)
            } else {
              controller._load(slideIndex)
            }

            if (!data.alreadyInPosition) {
              controller.currentComponentSet.slidedisplayer._scrollTo(slideIndex)
            }
          }

          if (slideIndex === 2) {
            $.slideshareEventManager.trackEvent("slidechange_2")
          } else if (slideIndex === controller.slideCount) {
            $.slideshareEventManager.trackEvent("slidechange_last")
          }

          $(document).trigger("slidechanged", [slideIndex])

          // update links
          if (!slideshare_object.utils.isResponsive()) {
            // Trigger only for desktop player
            $(window).trigger("resize")
          }
        },
        slidescrolled: function (data) {
          var slideIndex = data.index
          var controller = this.controller
          var currentPosition = controller.currentPosition
          if (currentPosition === slideIndex && !data.force) {
            return
          }
          this.trigger("slidechanged", data)
        },
        handlemultimedia: function () {
          var controller = this.controller
          if (controller.multimediaResource) {
            controller.wasPlaying = controller.multimediaResource.isPlaying()
            controller.multimediaResource.pause()
          }
        },
        screenoverlayclosed: function () {
          this.controller.multimediaResource &&
            this.controller.wasPlaying &&
            this.controller.multimediaResource.play()
        },
        showvideospinner: function () {
          var controller = this.controller
          controller.currentComponentSet.slidedisplayer.videoSpinner
            .css("z-index", controller.VIDEO_FULLSCREEN_ZINDEX)
            .show()
        },
        hidevideospinner: function () {
          var controller = this.controller
          controller.currentComponentSet.slidedisplayer.videoSpinner
            .css("z-index", "auto")
            .hide()
        },
        toolbarshown: function () {
          $(".toolbar").css("z-index", $(".slideDisplayer").css("z-index"))
        },
        currentversionloaded: function (data) {
          var slide = this.controller.slides[data.index]
          var resourceKey = data.resourceKey
          slide.updateRenderedResourceVersion(resourceKey)
        },
        resourceloaded: function (data) {
          // one of the resources for a slide has been loaded.
          // note that the resource has been loaded.
          // if all resources for the slide have been loaded, then fire the slideloaded event
          var slide = this.controller.slides[data.index]
          var resourceKey = data.resourceKey
          slide.updateResource(resourceKey, { status: "cached" })

          if (slide.status === "failed") {
            // this slide is marked as failed. Do not fire any events.
            return
          }
          var resources = slide.resources,
            key
          for (key in resources) {
            if (
              resources[key].cacheable === true &&
              resources[key].status !== "cached"
            ) {
              // something is still not cached. return.
              // need some kind of timeout handling
              return
            }
          }
          slide.status = "cached"
          this.trigger("slideloaded", { index: data.index })
        },
        resourceloadfailed: function (data) {
          var slide = this.controller.slides[data.index]
          var resourceKey = data.resourceKey
          slide.updateResource(resourceKey, { status: "failed" })
          if (slide.resources[resourceKey].isCritical === true) {
            slide.status = "failed"
            this.trigger("slideloadfailed", { index: data.index })
          }
          this.trackRawEvent(
            "jsplayer_debug",
            resourceKey + "_resourceloadfailed",
            undefined,
            true
          )
        },
        fontresourceloaded: function (data) {
          var controller = this.controller
          if (controller.config.use_ssl) {
            if (data.style.indexOf(".eot") !== -1) {
              data.style = data.style.replace(/http:\/\//g, "https://")
            }
          }
          var styleData = "<style>" + data.style + "</style>"
          $(styleData).appendTo(controller.currentComponentSet.container)
        },
        slideloaded: function (data) {
          var controller = this.controller
          var slideIndex = data.index
          var slide = controller.slides[slideIndex]

          if (slide.currentViewMode.rendered) {
            if (typeof new_mobile_player !== "undefined") {
              controller.resetSlideShowHeight(slideIndex)
            }
            slide.paint()
          }

          // First slide has been loaded, hide the facade.
          $("#playerFacade").hide()

          controller.preloadMoreIfIdle(slideIndex)
        },
        slideloadfailed: function (data) {
          const controller = this.controller
          var slide = controller.slides[data.index]

          // Error, hide the facade.
          $("#playerFacade").hide()

          if (slide.currentViewMode.rendered) {
            var width = slide.currentViewMode.width
            var height = slide.currentViewMode.height

            slide.displayError(
              controller.generateErrorDom("slide_error_template", {
                width: width,
                height: height,
              })
            )
          }

          controller.preloadMoreIfIdle(data.index)

          var slide_info = this.controller.config.id + "_slide_" + data.index
          this.trackRawEvent(
            "jsplayer_debug",
            "slideloadfailed",
            slide_info,
            true
          )
        },
        videoloadfailed: function () {
          this.trackRawEvent(
            "jsplayer_debug",
            "videoloadfailed",
            undefined,
            true
          )
        },
        slideloading: function (data) {
          var controller = this.controller
          var slide = controller.slides[data.index]

          var loadingSlides = controller.loadingSlides
          if (loadingSlides.indexOf(data.index) === -1) {
            controller.loadingSlides.push(data.index)
          }

          if (slide.currentViewMode.rendered) {
            slide.displayLoading()
          }
          if (controller.currentPosition === data.index) {
            this.trackRawEvent(
              "jsplayer_debug",
              "current_slide_loading",
              undefined,
              true
            )
          }
        },
        showvolumecontrol: function (data) {
          var toolbar = this.controller.currentComponentSet.toolbar
          toolbar && toolbar.volumeControl && toolbar.volumeControl.show()
        },
        hidevolumecontrol: function (data) {
          var toolbar = this.controller.currentComponentSet.toolbar
          toolbar && toolbar.volumeControl && toolbar.volumeControl.hide()
        },
        changevolume: function (data) {
          var controller = this.controller
          var multimediaResource = controller.multimediaResource
          multimediaResource && multimediaResource.changeVolume(data.volume)
        },
        volumechanged: function (data) {
          var toolbar = this.controller.currentComponentSet.toolbar
          toolbar &&
            toolbar.volumeControl &&
            toolbar.volumeControl.setVolume(data.volume)
        },
        repaint: function (data) {
          this.controller.repaint(data.mobile)
        },
        flag: function (data) {
          var flag = this.controller.currentComponentSet.flag
          if (flag) {
            flag.toggleFlagMenu()
          }
        },
      },
      registerController: function (controller) {
        this.controller = controller
      },
      registerPlayer: function (player) {
        this.player = $(player)
      },
      registerEnvironment: function (hostedIn) {
        hostedIn = hostedIn || "slideshare"
        this.hostedIn = hostedIn
      },
      trigger: function (eventname, data) {
        var that = this
        if (this.functions[eventname] !== undefined) {
          this.functions[eventname].call(this, data)
        }

        if (this.SHOUTEVENTS[eventname]) {
          this.player.trigger({
            type: eventname,
            ssData: data,
          })
        }
      },
      trackEvent: function (label, isNonInteractiveEvent) {
        if (!window._gaq) {
          window._gaq = []
        }
        window._gaq.push([
          "_trackEvent",
          "jsplayer",
          this.hostedIn,
          label,
          undefined,
          !!isNonInteractiveEvent,
        ])
      },
      trackRawEvent: function (category, action, label, isNonInteractiveEvent) {
        if (!window._gaq) {
          window._gaq = []
        }
        window._gaq.push([
          "_trackEvent",
          category,
          action,
          label,
          undefined,
          !!isNonInteractiveEvent,
        ])
      },
      trackValueEvent: function (
        category,
        action,
        optional_label,
        optional_value
      ) {
        if (!window._gaq) {
          window._gaq = []
        }
        window._gaq.push([
          "_trackEvent",
          category,
          action,
          optional_label,
          optional_value,
        ])
      },
      trackOutboundClick: function (target) {
        this.controller.clickGenTracker.trackOrganicLinkClickEvent(target)
      },
      getController: function () {
        return this.controller
      },
      getCurrentPosition: function () {
        return this.controller.currentPosition
      },
      trackAmplitudeEvent: function (name, options) {
        // Amplitude not present for embedded slideshows
        if (typeof amplitude !== "undefined") {
          amplitude.getInstance().logEvent(name, options)
        }
      },
      identifyAmplitude: function (key, value) {
        if (typeof amplitude !== "undefined" && !hasIdentifiedAmplitude) {
          var scribdAdIdentity = new amplitude.Identify().set(key, value)

          amplitude.getInstance().identify(scribdAdIdentity)
          hasIdentifiedAmplitude = true
        }
      },
    },
  })
}
